// Cliente API del módulo "Leads / Prospectos" (call center IA).
// Llama a Orión /orion/api/leads/phone (JWT → org). Mismo patrón de auth
// (Bearer de localStorage) que client-radar/api.ts.

import type { PhoneLead, PhoneLeadsResponse, LeadEstatus } from './types';

const ORION = '/orion/api';
const BASE = '/leads';

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token ?? ''}` };
}

async function asJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${res.status} ${res.statusText} — ${body.slice(0, 200)}`);
  }
  return res.json() as Promise<T>;
}

export async function listLeads(estatus?: string): Promise<PhoneLeadsResponse> {
  const qs = estatus ? `?estatus=${encodeURIComponent(estatus)}` : '';
  const res = await fetch(`${ORION}${BASE}/phone${qs}`, { headers: authHeaders() });
  return asJson<PhoneLeadsResponse>(res);
}

export async function updateLeadStatus(id: string, estatus: LeadEstatus): Promise<PhoneLead> {
  const res = await fetch(`${ORION}${BASE}/phone/${encodeURIComponent(id)}/status`, {
    method: 'PATCH',
    headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ estatus }),
  });
  return asJson<PhoneLead>(res);
}
